var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navigation"},[_c('ul',{staticClass:"navigation__list"},_vm._l((_vm.links),function(ref){
var name = ref.name;
var href = ref.href;
return _c('li',{key:href,staticClass:"navigation__item"},[_c('router-link',{staticClass:"navigation__link hover-underline",class:{ 'navigation__link--exact-only': href === '/' },attrs:{"to":href},nativeOn:{"click":function($event){return _vm.closeMenu($event)}}},[_vm._v("\n        "+_vm._s(name)+"\n      ")])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }